import styled from "styled-components";

const SelectPassengerApplyBox = styled.div`
  padding-bottom: 25px;
`;

export default SelectPassengerApplyBox;
